import React from "react";
import Header3 from "../header3";

export default function Navbar3({tournament,...props}) {
  const [scroll, setScroll] = React.useState(0);

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active" : "fixed-navbar";

  return (
    <div className={className}>
        <Header3 tournament={tournament} hclass={props.hclass} topbarClass={props.topbarClass} Logo={props.Logo}/>
    </div>
  );
}